import { useIntl } from 'react-intl';

import styles from '@components/expert/ExpertDashboardPage.module.css';
import ExpertMessage from '@components/expert/ExpertMessage';
import Tag from '@components/labels/Tag';
import { GetExpertUnreadMessagesQuery } from '@typing/Generated';
import { sortByTimestamp } from '@utils/modelUtils';

type MessageType = NonNullable<
  NonNullable<NonNullable<GetExpertUnreadMessagesQuery['expertUnreadMessages']['edges']>[number]>['node']
>;

type Props = {
  group: MessageType[];
  journeyId: string;
  markJourneyMessagesRead: () => void;
};

const ExpertMessageGroup = ({ group, journeyId, markJourneyMessagesRead }: Props) => {
  const intl = useIntl();

  return (
    <div className={styles.messageGroup}>
      <div className="ion-margin-start ion-margin-top bold">
        <Tag
          color="secondary500"
          text={intl.formatMessage(
            { id: 'pages.expert.dashboard.lovedOne' },
            { name: group[0].chat.journey.careProfile.name }
          )}
        />
      </div>
      {sortByTimestamp(group, message => message.createdAt).map((message, index) => (
        <div className={styles.message} key={message.id}>
          <ExpertMessage
            hideControls={index !== 0}
            journeyId={journeyId}
            markJourneyMessagesRead={markJourneyMessagesRead}
            message={message}
          />
        </div>
      ))}
    </div>
  );
};

export default ExpertMessageGroup;
